import {hasActiveTelcoStatus} from "./teamFilters";
import {Laptop, type LucideIcon, Smartphone, Wifi} from "lucide-react";

const CONNECTION: Record<string, {label: string; Icon: LucideIcon}> = {
    WIFI: {label: 'On Wi‑Fi', Icon: Wifi},
    CELLULAR: {label: 'On mobile data', Icon: Smartphone},
    DESKTOP: {label: 'On computer', Icon: Laptop},
};

export const ConnectionTypeIcon = ({member, size = 14}: {
    member: {
        connectionUserStatus?: {type: string} | null;
        telcoUserStatus?: {status?: string} | null;
    };
    size?: number;
}) => {
    const type = member.connectionUserStatus?.type;
    const entry = type ? CONNECTION[type] : undefined;
    if (!entry || !hasActiveTelcoStatus(member)) {
        return null;
    }
    const {label, Icon} = entry;
    return (
        <span
            role="img"
            title={label}
            aria-label={label}
            data-connection-type={type}
            className="inline-flex shrink-0 items-center text-ink-muted"
        >
            <Icon size={size}/>
        </span>
    );
};
